<input
  class="az-input"
  [class.disabled]="disabled"
  [type]="type"
  [(ngModel)]="value"
  [placeholder]="placeholder"
  [disabled]="disabled"
  (ngModelChange)="onInputChange($event)"
/>
